import { Box } from "@mui/material";
import { t } from "../dashboard/coach/coachTokens";

/**
 * Brand action button matching the TopNav "לקוח חדש" CTA. variant="primary" is the filled green
 * button; variant="secondary" is the outlined neutral one. Icon goes on the right (RTL) via the
 * `icon` prop, rendered at 16px with a 5px gap — same as the header button.
 */
const BrandButton = ({ children, icon, onClick, disabled, variant = "primary", sx = {} }) => {
  const base = {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    height: 36,
    px: "15px",
    borderRadius: t.rs,
    fontSize: "13px",
    fontWeight: 600,
    letterSpacing: "-0.1px",
    cursor: disabled ? "default" : "pointer",
    fontFamily: "inherit",
    transition: "all .14s",
    whiteSpace: "nowrap",
    opacity: disabled ? 0.55 : 1,
  };

  const variants = {
    primary: {
      background: t.green,
      color: "#fff",
      border: "none",
      "&:hover": disabled ? {} : { background: t.greenDark, transform: "translateY(-1px)", boxShadow: "0 4px 12px rgba(1,187,167,.35)" },
    },
    secondary: {
      background: t.white,
      color: t.t2,
      border: `1px solid ${t.border}`,
      "&:hover": disabled ? {} : { borderColor: t.green, color: t.green, background: t.greenLight },
    },
  };

  return (
    <Box component="button" type="button" onClick={disabled ? undefined : onClick} disabled={disabled}
      sx={{ ...base, ...variants[variant], ...sx }}>
      {icon}
      {children}
    </Box>
  );
};

export default BrandButton;
